let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jqOKH")).then(() => parcelRequire('acqAM'));